import React, {Component} from 'react';
import './styles.scss';

export default class HeaderPhoto extends Component {
  render() {
    return (
      <div className="component-header-photo">
        <div className="header">
          <p>{this.props.title}</p>
          <div className="header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.89 81.42">
              <g id="Layer_2" data-name="Layer 2">
                <g id="Header">
                  <g id="user">
                    <rect className="cls-1" x="2.45" width="72" height="72" />
                  </g>
                  <circle className="cls-2" cx="38.45" cy="42.98" r="37.69" />
                  <path
                    className="cls-3"
                    d="M45.17,41.7a12.76,12.76,0,0,0,5.91-10.62,12.64,12.64,0,0,0-25.27,0A12.76,12.76,0,0,0,31.72,41.7c-7.83,2.37-12.6,9.06-12.6,18.36a1.49,1.49,0,0,0,1.49,1.49H56.28a1.49,1.49,0,0,0,1.49-1.49C57.77,50.76,53,44.07,45.17,41.7ZM28.78,31.08a9.67,9.67,0,1,1,9.67,9.66A9.8,9.8,0,0,1,28.78,31.08Zm-6.64,27.5c.59-8.92,6.73-14.86,16.31-14.86s15.71,5.94,16.3,14.86Z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}
